require('./transactionInfo.scss')

module.exports = {
  template: require('./transactionInfo.pug')()
  controller: require('./transactionInfo.ctrl')
  bindings:
    statementRecord: '<'
    onRevert: '&'
}
